module.exports = __webpack_public_path__ + "static/media/baouLogo.0a3f7ee2.png";